import React, { useRef } from "react";
import Carousel from "./Carousel";
import Client from "./Client";
import Header from "../layout/Header";
import HeroFigma from "../layout/HeroFigma"
import ProductSlider from "../layout/ProductSlider";
import ProductCard from "../Home/productsNewDesign/ProductCards"
import ProductList from "../Home/productsNewDesign/ProductList"
import Shop from "./Shop";
import SingleProductList from "./productsNewDesign/SingleProductList";

function Home({ productListRef }) {

  return (
    <>
      <div className="main-bg">
        <Header />

        {/* New added componets starts here */}
        {/* <HeroFigma /> */}
        {/* <ProductSlider /> */}
        <SingleProductList />
        <div id="home-carousel">
          <Carousel />
        </div>
        <ProductCard />
        <ProductList ref={productListRef} />
        {/* New added componets ends here */}

        {/* <Shop /> */}
        <Client />
      </div>
    </>
  );
}

export default Home;
